import { render, staticRenderFns } from "./DetailsDrawer.vue?vue&type=template&id=5a6b0ab4&scoped=true"
import script from "./DetailsDrawer.vue?vue&type=script&lang=js"
export * from "./DetailsDrawer.vue?vue&type=script&lang=js"
import style0 from "./DetailsDrawer.vue?vue&type=style&index=0&id=5a6b0ab4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6b0ab4",
  null
  
)

export default component.exports